import { usePrompt } from '@/presentation/hooks/use-prompt';
import { useCallback } from 'react';
import { useBeforeUnload } from 'react-router-dom';
const RouterPrompt = ({ hasUnsavedChanges, customMessage = 'You have unsaved changes, are you sure you want to leave?' }) => {
    const onLocationChange = useCallback(({ nextLocation }) => {
        /*
          if (!stepLinks.includes(nextLocation.pathname) && hasUnsavedChanges) {
          return !window.confirm(customMessage);
        }
        */
        console.log('nextLocation:', nextLocation);
        return !window.confirm(customMessage);
        // return false;
    }, [hasUnsavedChanges]);
    usePrompt(onLocationChange, hasUnsavedChanges);
    useBeforeUnload(useCallback(event => {
        if (hasUnsavedChanges) {
            event.preventDefault();
            event.returnValue = '';
        }
    }, [hasUnsavedChanges]), { capture: true });
    return null;
};
export default RouterPrompt;
